import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AIChatbot from "./components/AIChatbot";
import ContactModal from "./components/ContactModal";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AIStemKidzPage from "./pages/AIStemKidzPage";

function AppContent() {
  const [auditModalOpen, setAuditModalOpen] = useState(false);

  return (
    <div className="App min-h-screen bg-[var(--bg-default)]">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/ai-stem-kidz" element={<AIStemKidzPage />} />
        </Routes>
      </main>
      <Footer onOpenAudit={() => setAuditModalOpen(true)} />
      <AIChatbot />
      <ContactModal
        isOpen={auditModalOpen}
        onClose={() => setAuditModalOpen(false)}
        type="audit"
      />
      <Toaster position="top-right" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
